/**
 * Returns the environment color, or null for production.
 */
export function getEnvColor(): string | null {
  const env = import.meta.env.VITE_SENTRY_ENVIRONMENT;
  if (env === "production") return null;
  if (env === "preproduction") return "#FF8C00";
  return "#92bf0a"; // dev / preview / undefined
}

/**
 * Dynamically adds a colored dot to the favicon based on environment.
 */
export function applyDynamicFavicon() {
  const color = getEnvColor();
  if (!color) return;

  const img = new Image();
  img.src = "/favicon.png";
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.drawImage(img, 0, 0);
    const r = img.width * 0.2;
    ctx.beginPath();
    ctx.arc(img.width - r, img.height - r, r, 0, Math.PI * 2);
    ctx.fillStyle = color;
    ctx.fill();
    const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (link) link.href = canvas.toDataURL("image/png");
  };
}

/**
 * Injects a fixed 2px color bar at the top of the page (overlay, no layout shift).
 */
export function applyEnvBar() {
  const color = getEnvColor();
  if (!color) return;

  const bar = document.createElement("div");
  bar.id = "env-bar";
  bar.style.cssText = `position:fixed;top:0;left:0;right:0;height:2px;background:${color};z-index:99999;pointer-events:none;`;
  document.body.prepend(bar);
}
